import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import { getStoryElementByType } from "../../../utils";
import { Partner } from "./Partner";
import "./partner-container.m.css";

export const PartnerContainer = ({ card, cdnImage, type, imageSrc }) => {


  const elementType = getStoryElementByType(card, "image", "title", "image-s3-key");
  const title = get(getStoryElementByType(card, "title"), ["text"], "");
  const description = get(getStoryElementByType(card, "text"), ["text"], "");
  const compositeElement = getStoryElementByType(card, "composite");
  const id = get(card, ["metadata", "attributes", "menuname", "0"], "");
  console.log("elementType", elementType);
  return (
    <section styleName="partner-container" id={`${id.toLowerCase()}`}>
      <div styleName="partner-content">
        <h2 styleName="partner-heading" dangerouslySetInnerHTML={{ __html: title }} />
        {/* <div dangerouslySetInnerHTML={{ __html: description }} /> */}
        <section styleName="partners-section" aria-label="Partners Section">
          {elementType?.type === 'image' && <div styleName="special-partnersbox"><p styleName="special-partner-type">{elementType?.title}</p><a href={elementType?.hyperlink}><img src={`https://media.fortuneindia.com/${elementType?.['image-s3-key']}`} alt={`${elementType?.['alt-text']} logo`} styleName="special-partner-image" /></a></div>}
          <div styleName="partner-row">
            {compositeElement?.["story-elements"]?.map((element) => {

              const type = get(element, ["title"], "");
              const hyperLink = get(element, ["hyperlink"], "");
              const imageSrc = `${cdnImage}/${get(element, ["image-s3-key"], "")}`;
              return <Partner type={type} imageSrc={imageSrc} imageClassName="partner-image" hyperLink={hyperLink} elementType={elementType} />;
            })}
            {/* <Partner type="STYLING PARTNER" logoClassName="partner-logo" />
            <Partner
              type="STYLING PARTNER"
              imageSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/c4102a815d610a923f6364e696b3e1033cc08f14?placeholderIfAbsent=true&apiKey=870030d6f716462a820bd51c69c8828f"
              imageClassName="partner-image-2"
            />
            <div styleName="partner-item">
              <p styleName="partner-type">STYLING PARTNER</p>
              <div styleName="partner-logo-container">
                <MicrosoftLogo />
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/29480b089a85ac6a9ec4353a8bef7dc9c2695a53?placeholderIfAbsent=true&apiKey=870030d6f716462a820bd51c69c8828f"
                  alt="Microsoft"
                  styleName="partner-image-3"
                />
              </div>
            </div> */}
          </div>
          {/* <div styleName="partner-row-2">
            <Partner
              type="STYLING PARTNER"
              imageSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/fb5b87914227d9e4ea2150b158107a6a83489bd6?placeholderIfAbsent=true&apiKey=870030d6f716462a820bd51c69c8828f"
              imageClassName="partner-image-4"
              containerClassName="partner-item-2"
            />
            <Partner type="STYLING PARTNER" logoClassName="partner-logo-2" containerClassName="partner-item-3" />
          </div> */}
        </section>
      </div>
    </section>
  );
};

PartnerContainer.propTypes = {
  refKey: PropTypes.object,
};
